import { Col, Container, Row } from 'react-bootstrap'
import { getIntegrationDisplayName, IntegrationServiceId } from '../../../../../../common/integrations'
import { IntegrationLoginURLSetting } from '../../../IntegrationSpecificSettings/IntegrationLoginURLSetting'
import { useGetIntegrationAdminSettings } from '../../hooks'
import { ExportActionsSettings } from './ExportActionsSettings'

export interface GeneralAdminSettingsProps {
  serviceId: IntegrationServiceId
  showLoginUrl?: boolean
}

export const GeneralAdminSettings: React.FC<GeneralAdminSettingsProps> = ({ serviceId, showLoginUrl = false }) => {
  const integrationDisplayName = getIntegrationDisplayName(serviceId)
  const { isAccountLoading } = useGetIntegrationAdminSettings(serviceId)

  if (isAccountLoading) {
    return (
      <Container>
        <div className='skeleton pt-2' style={{ width: '100%', height: '60px' }} />
        <div className='skeleton pt-2' style={{ width: '100%', height: '60px' }} />
      </Container>
    )
  }

  return (
    <Container className='py-3'>
      {showLoginUrl ? (
        <>
          <Row className='mb-3'>
            <Col>
              <h3 className='mb-2'>URL</h3>
            </Col>
          </Row>
          <Row className='mb-5'>
            <Col>
              <IntegrationLoginURLSetting serviceId={serviceId} />
            </Col>
          </Row>
        </>
      ) : null}
      <Row className='mb-3'>
        <Col>
          <h3 className='mb-2'>Export actions</h3>
          <div className='zocks-text-gray-600'>Manage the export actions users can trigger from Zocks to {integrationDisplayName}.</div>
        </Col>
      </Row>
      <ExportActionsSettings serviceId={serviceId} />
    </Container>
  )
}
